@tailwind base;
@tailwind components;
@tailwind utilities;

:host {
  @apply w-full h-[35px] block;
}
